import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { SContainer, STitle } from './payment-operation.layout.style';

const PaymentOperationLayout = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <SContainer>
      <STitle>{t('paymentOperation.title')}</STitle>
      <Outlet />
    </SContainer>
  );
};

export default PaymentOperationLayout;
